<section class="main-section form-section">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item" *ngIf="user.role === 'ROLE_ADMIN'"><a routerLink="/admin/adminDashboard/">Home</a>
      </li>
      <li class="breadcrumb-item" *ngIf="user.role === 'ACCOUNT_OWNER'"><a routerLink="/admin/dashboard/">Home</a></li>
      <li class="breadcrumb-item" *ngIf="user.role === 'ROLE_ADMIN'"><a routerLink="/admin/adminReturns/">Returns</a>
      </li>
      <li class="breadcrumb-item" *ngIf="user.role === 'ACCOUNT_OWNER'"><a routerLink="/admin/returns/">Returns</a></li>
      <li class="breadcrumb-item" *ngIf="user.role === 'AO_SELLER'"><a routerLink="/admin/sellerDashboard/">Returns</a>
      </li>
      <li class="breadcrumb-item active" aria-current="page">View Return</li>
    </ol>
  </nav>

  <div class="row">
    <div class=" col-xs-12 col-md-4 offset-md-8 col-lg-4 offset-lg-8 col-sm-4 offset-sm-8">
    </div>
  </div>
  <form>
    <div class="row mt-3">
      <div class="col">
        <div class="inner-box">
          <h2>Recipient Information</h2><br>
          <div class="row mt-3">
            <div class="col-4">
              <label class="mb-1 control-label"><b>Order Number</b> : {{viewReturnOrder?.orderNumber}}</label><br>
              <label class="mb-1 control-label"><b>Status</b> : {{viewReturnOrder?.orderStatus}}</label><br>
              <label class="mb-1 control-label"><b>Connection Name</b> : {{viewReturnOrder?.connectionName}}</label>
            </div>
            <div class="col-4">
              <label class="mb-1 control-label"><b>Sender Name</b> : {{viewReturnOrder?.senderName}}</label><br>
              <label class="mb-1 control-label"><b>Company Name</b> : {{viewReturnOrder?.senderCompanyName}}</label><br>
              <label class="mb-1 control-label"><b>Phone No </b> : {{viewReturnOrder?.senderMobile}}</label><br>
              <label class="mb-1 control-label"><b>Email</b> : {{viewReturnOrder?.senderEmail}}</label><br>
              <label class="mb-1 control-label"><b>Address</b> : {{viewReturnOrder?.senderAddressText}}</label>
            </div>
            <div class="col-4">
              <label class="mb-1 control-label"><b>Receiver Name</b> : {{viewReturnOrder?.receiverName}}</label><br>
              <label class="mb-1 control-label"><b>Company Name</b> : {{viewReturnOrder?.receiverCompanyName}}
              </label><br>
              <label class="mb-1 control-label"><b>Phone No </b> : {{viewReturnOrder?.receiverMobile}}</label><br>
              <label class="mb-1 control-label"><b>Email</b> : {{viewReturnOrder?.receiverEmail}}</label><br>
              <label class="mb-1 control-label"><b>Address</b> : {{viewReturnOrder?.receiverAddressText}}</label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col">
        <ul class="list-inline tab-list">
          <li class="list-inline-item"><a class="list-inline-item" (click)=" tabChange('selectedProducts');"
                                          [ngClass]="{'active': tabClicked === 'selectedProducts'}">Selected
            Products</a></li>
          <li class="list-inline-item"><a class="nav-link warehouses" (click)=" tabChange('shippingOptions');"
                                          [ngClass]="{'active': tabClicked === 'shippingOptions'}">Shipping Options</a>
          </li>
        </ul>
        <div class="inner-box">
          <div class="row mt-3" *ngIf="tabClicked == 'selectedProducts'">
            <div class="col-12">
              <div class="table-3">
                <table class="table  packing-table-2">
                  <thead class="thead-light">
                  <tr>
                    <th>Product Name</th>
                    <th>SKU</th>
                    <th>Quantity</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr *ngFor="let ol of orderLines">
                    <td>{{ol.productName}}</td>
                    <td>{{ol.sku}}</td>
                    <td>{{ol.quantity}}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="col-12 mt-3">
              <label class="text-black"><b>Return Reason :</b><span
                class="ml-1">{{viewReturnOrder?.returnReason || '--'}}</span></label>
            </div>
          </div>

          <div class="mt-4" *ngIf="tabClicked == 'shippingOptions'">
            <div class="row" *ngIf="viewReturnOrder.orderStatus !='SUBMITTED'">
              <div class="col-md-12  dip-in">
                <div class="form-radio mr-5">
                  <input type="radio" id="shift" [(ngModel)]="viewReturnOrder.shippingOption"
                         [ngModelOptions]="{standalone: true}" required value="SHIFT" disabled>
                  <label for="shift">Shift</label>
                </div>
                <br><br>
                <div class="form-radio">
                  <input type="radio" id="Regular" [(ngModel)]="viewReturnOrder.shippingOption"
                         [ngModelOptions]="{standalone: true}" required value="THIRD_PARTY" disabled>
                  <label for="Regular">Third Party Carriers
                    <p class="label-para-size">(Shift will chose the cheapest and fastest carrier)</p>
                  </label>
                </div>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-md-5">
                <h2 class="text-black mb-3">Shipping Instructions</h2>
                <label class="mb-1 control-label">{{viewReturnOrder?.deliveryInstructions || '--'}}</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>


</section>
<div class="form-btn-section">
  <div class="row">
    <div class="col-12 text-right">
      <button type="reset" *ngIf="user.role == 'ACCOUNT_OWNER'" routerLink="/admin/returns" class="btn btn-cancel">
        Close
      </button>
      <button type="reset" *ngIf="user.role == 'ROLE_ADMIN'" routerLink="/admin/adminReturns" class="btn btn-cancel">
        Close
      </button>
    </div>
  </div>
</div>

